import { Button, Alert } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
// import Button from '@mui/material/Button';

import { Props } from "./interface";
import { Actions, SaveButton } from "./styles";
import Spinner from "../Spinner/Spinner";

const DialogActions = ({
  handleCancel,
  handleSave,
  handleDelete,
  canBeDeleted,
  disabledSaveButton = false,
  disabledCancelButton = false,
  customSaveName,
  customDeleteName,
  customCancelName,
  error,
  loading,
  children,
  useGoback,
  saveButtonOrder,
  saveButtonTooltip,
  customSaveStyle,
}: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Actions>
      <Button
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          handleCancel();
        }}
        variant="outlined"
        disabled={disabledCancelButton}
        style={{
          order: 0,
          color: theme.palette.actions.cancel,
          borderColor: theme.palette.actions.cancel,
        }}
      >
        {customCancelName ? customCancelName : useGoback ? t("buttons.go_back") : t("buttons.cancel")}
        {/* {`${t("buttons.go_back")}`} */}
      </Button>

      {error && <Alert severity="error">{error}</Alert>}

      {loading && (
        <Spinner
          size="3x"
          color={theme.palette.primary.main}
        />
      )}

      {handleDelete && canBeDeleted && (
        <SaveButton
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            handleDelete();
          }}
          variant="contained"
          disabled={disabledSaveButton || loading}
          color="error"
          // style={{
          //   color: theme.palette.error.main,
          //   borderColor: theme.palette.error.main,
          // }}
        >
          <>{customDeleteName ?? t("buttons.delete")}</>
        </SaveButton>
      )}

      {handleSave && (
        <SaveButton
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            handleSave();
          }}
          variant="contained"
          disabled={disabledSaveButton || loading}
          style={{ ...customSaveStyle, order: saveButtonOrder ?? 1, pointerEvents: "auto" }}
          title={saveButtonTooltip ?? customSaveName ?? t("buttons.save")}
        >
          <>{customSaveName ?? t("buttons.save")}</>
        </SaveButton>
      )}

      {children}
    </Actions>
  );
};

export default DialogActions;
